import { getAuthState, getSignInStep } from './Amplify.selectors';

import { types as AmplifyActionTypes } from './Amplify.actions';
import AuthActions from '../Auth.actions';
import { rememberMe } from '../../services';
import { shouldRemember } from '../Auth.selectors';

export default ({ dispatch, getState }) =>
    next =>
    action => {
        const result = next(action);
        const { type } = action;
        if (type) {
            switch (type) {
                case AmplifyActionTypes.nextStep: {
                    const newState = getState();
                    const signInStep = getSignInStep(newState);
                    if (signInStep === 'DONE' && shouldRemember(newState)) {
                        // We cannot remember the device until the user is completely signed in
                        rememberMe();
                    }
                    // Fix the Auth state based on amplify updates
                    dispatch(AuthActions.updateAuthState(getAuthState(getState())));
                    break;
                }
                case AmplifyActionTypes.updateUserAttributesSuccess: {
                    // We mutated the payload so the new attributes are included for the middleware, so we don't loop everything again or update something that shouldn't be updated
                    const { params, attributes = params } = action.payload;
                    dispatch(AuthActions.updateUserAttributesSuccess(params, attributes));
                    break;
                }
            }
        }

        return result;
    };
